export const BIRTH = 'birth'
export const FULL_NAME = 'fullName'
export const NOTES = 'notes'
export const PARENTAL_RESPONSIBILITY_OF = 'parentalResponsibilityOf'
export const IS_ALIVE = 'isAlive'
export const DIED_BEFORE_DECEASED = 'diedBeforeDeceased'
export const IS_OVER_EIGHTEEN = 'isOverEighteen'
export const HAS_LIVING_CHILDREN = 'hasLivingChildren'
export const RELATIONSHIP_TO_DECEASED = 'relationshipToDeceased'
